// services/session.ts
import Cookies from 'js-cookie'
import { nanoid } from 'nanoid'

const SESSION_COOKIE_NAME = 'session_id'

export const getSessionId = (): string | undefined => Cookies.get(SESSION_COOKIE_NAME)
export const createSessionId = (): string => {
  const newSessionId = nanoid()
  Cookies.set(SESSION_COOKIE_NAME, newSessionId, { path: '/', secure: true, sameSite: 'Lax' })
  return newSessionId
}
